app.service('PatientAPI', ['$http', 'ENV', 'Session', function($http, ENV, Session) {

	var service = {
		isProcessing: false,

		isFavouriteResponseSuccess: function (status) {
			return status === 200 || status === 202 || status === 204;
		},

		search: function (lastName, dob, searchTerm, nhi) {
			if(searchTerm){
				const parameter_dob = dob ? "&dob=" + encodeURIComponent(dob) : "";
				return $http({
					method: "GET",
					url: ENV.API + "/api/patients?" + parameter_dob + "&searchTerm=" + encodeURIComponent(searchTerm) + '&searchType=ADVANCED',
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			}

			if(nhi){
				return $http({
					method: 'GET',
					url: ENV.API + '/api/patients?nhi=' + encodeURIComponent(nhi) + '&searchType=NHI',
					headers: {
						'Authorization': 'Bearer ' + Session.token,
					}
				}) 
			}
			
			return $http({
				method: 'GET',
				url: ENV.API + '/api/patients?lastName=' + encodeURIComponent(lastName) + '&dob=' + encodeURIComponent(dob) + '&searchType=BASIC',
				headers: {
					'Authorization': 'Bearer ' + Session.token,
				}
			})
		},
		transfer: function (patientId, referrer, practice) {
			return $http({
				method: "POST",
				url: ENV.API + "/api/patients/" + patientId + "/transfer",
				headers: {
					Authorization: "Bearer " + Session.token,
					"Content-Type": "application/json",
				},
				data: {
					referrer: {
						id: referrer,
					},
					practice: {
						id: practice,
					},
				},
			});
		},

		create: function (patient, sendEmr) {
			const _sendEmr = sendEmr == undefined ? false : sendEmr;
			return $http({
				method: "POST",
				url: ENV.API + "/api/patients?sendEmr=" + _sendEmr,
				headers: {
					Authorization: "Bearer " + Session.token,
					"Content-Type": "application/json",
				},
				data: patient,
			});
		},

		update: function (patient, sendEmr) {
			const _sendEmr = sendEmr == undefined ? false : sendEmr;
			return $http({
				method: "PUT",
				url: ENV.API + "/api/patients/" + patient.id + "?sendEmr=" + _sendEmr,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
				data: patient,
			});
		},

		fetchDocument: function (patientId) {
			return $http({
				method: "GET",
				url: ENV.API + "/api/documents/patient/" + patientId,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},

		downloadDocument: function (patientId, documentId, docType) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/documents/patient/${patientId}/document/${docType}/${documentId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
				responseType: "arraybuffer",
			});
		},
		addToFavourite: function (patientId) {
			return $http({
				method: "PATCH",
				url: ENV.API + `/api/users/${Session.userId}/features/favorite_patients/` + patientId,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
			});
		},
		removeFavourite: function (patientId) {
			return $http({
				method: "DELETE",
				url: ENV.API + `/api/users/${Session.userId}/features/favorite_patients/` + patientId,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
			});
		},
		getPatient: function (patientId,practiceId = Session.practice.id) {
			return $http({
				method: "GET",
				url: ENV.API + "/api/patients/" + patientId,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			});
		},
		getVisionChart: function (patientId, chartName) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/chart/patient/${patientId}/vision?chartName=${encodeURIComponent(chartName)}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},
		addToRecentPatients: function (patientId) {
			return $http({
				method: "PATCH",
				url: ENV.API + `/api/users/${Session.userId}/features/recent_patients/` + patientId,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},
		getPractitioners: function (patientId,canceler) {
			return $http({
				method: "GET",
				url: ENV.API + "/api/hpi/patient/" + patientId + "/general-practitioners",
				timeout: canceler.promise,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},
		// There is no sendContactVerification() here any more. A verification is sent by saving the
		// patient: update() above issues a fresh token server-side whenever the save changes the email
		// or the mobile number. POST /api/patient-verification/send/{patientId} still exists as a
		// staff-driven send, but nothing in this front end calls it.
		//
		// Validating and completing a verification token goes through PatientFormsAPI, which talks to
		// the shared /api/patient-tokens endpoints.
	};

	return service;
}])
